<template>
  <div class="page" :style="bgStyle">
    <div class="descarga-layout">
      <p class="subtitulo">Encuesta de satisfacción</p>
      <div class="btns-col">
        <!-- Llenar encuesta en línea -->
        <img
          src="/mexa/boton-encuesta.png"
          class="btn-accion"
          alt="Llenar encuesta"
          @click="$router.push('/encuesta')"
        />
        <!-- Descargar documento Word -->
        <a href="/mexa/encuesta.docx" download="encuesta-convencion2026.docx">
          <img src="/mexa/boton-descarga-encuesta.png" class="btn-accion" alt="Descargar encuesta" />
        </a>
        <!-- Regresar -->
        <img
          src="/mexa/boton-regresar.png"
          class="btn-accion"
          alt="Regresar"
          @click="$router.push('/')"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DescargaEncuestaView',
  data() {
    return {
      isMobile: window.innerWidth <= 768
    }
  },
  computed: {
    bgStyle() {
      const img = this.isMobile ? '/mexa/fondo-movil.jpg' : '/mexa/fondo-descarga.jpg'
      return {
        backgroundImage: `url(${img})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat'
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth <= 768
    }
  }
}
</script>

<style scoped>
.page {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.descarga-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
  padding: clamp(300px, 55vh, 500px) 16px 32px;
  padding-left: 16%;
}

.subtitulo {
  color: #fff;
  font-size: clamp(18px, 2.5vw, 28px);
  font-family: TelefonicaRegular, sans-serif;
  text-align: center;
  text-shadow: 0 2px 8px rgba(0,0,0,0.3);
}

.btns-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.btn-accion {
  height: clamp(48px, 6vw, 64px);
  width: auto;
  cursor: pointer;
  transition: transform 0.15s, filter 0.15s;
  display: block;
}
.btn-accion:hover  { transform: scale(1.05); filter: brightness(1.08); }
.btn-accion:active { transform: scale(0.97); }
</style>
